import React from "react";
import { jsx } from "slate-hyperscript";
import { BlockHandler, ElementType } from "./base";

BlockHandler.register(ElementType.UNORDERED_LIST, {
    nodeTypes: ["UL"],
    toBlock: child => <ul>{child}</ul>,
    serialize: child => `<ul>${child}</ul>`,
    deserialize: children => jsx("element", { type: ElementType.UNORDERED_LIST }, children),

});
